import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { TableCell } from '@design/components/table';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import { SmartTableCellProps } from '../SmartTable.types';
import styles from './SmartTableCell.module.scss';

const isNumber = (data: unknown) => typeof data === 'number';

export const SmartTableCell = <T extends {}>({
  item,
  column,
  alignment,
  hasScrollbar,
  className,
  ...rest
}: SmartTableCellProps<T>) => {
  let content;

  if (item.isLoading) {
    content = (
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: '20px',
              borderRadius: '8px',
            },
          },
        ]}
      />
    );
  } else {
    content = column.render
      ? column.render(item[column.key], item)
      : item[column.key];
  }

  return column.sticky ? (
    <TableCell
      className={clsx(
        styles.stickyTableCell,
        { [styles.stickyTableCellBorder]: hasScrollbar },
        className
      )}
      alignment={alignment}
      key={column.key}
      isNumber={isNumber(content)}
      {...rest}
    >
      {content as ReactNode}
    </TableCell>
  ) : (
    <TableCell
      className={className}
      key={column.key}
      alignment={alignment}
      isNumber={isNumber(content)}
      {...rest}
    >
      {content as ReactNode}
    </TableCell>
  );
};
